import React, { Component } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperInputComponent,
    FormWrapperItem,
    ListComponent
} from "../../../common/component/Index";
import i18n from "../../../../../constants/initLng";
import { PATHS, SUPPLIER_CATEGORY, SUPPLIER, RATECODE } from "../../../../../constants/Define";
import { message, Checkbox, InputNumber, Switch, Icon, Popover, DatePicker } from 'antd';
import moment from 'moment';
import AntSelect, { AntOptGroup, AntOption } from '../../../common/component/AntSelect';
import { isEqual, findIndex, find, toArray, groupBy, chain } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import { SupplierProduct } from '../../../../../models/Supplier';
import Wrapper from '../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { checkUndefine } from '../../../../../helpers/functions';
import { minValueNumber } from 'helpers/validation';

const CheckboxGroup = Checkbox.Group
const defaultState = {
    action: "CREATE",
    validation: {},
};

const ListCols = ['code', 'name', 'type', 'content'];
class KeylistComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vinWonderRefIds: [],
            refIdPopoverConent: "",
            titleItemTable: Func.getTitleTable(ListCols, [], []),
            componentTable: {
                type: {
                    key: 'type',
                    render: (type, record)=> ( type === 0 || type === 1 ) && SUPPLIER_CATEGORY.KEY_TYPE[type === 0 ? 'NUMBER' : 'STRING'].label
                },
                content: {
                    key: 'content',
                    render: (text, record, idx)=> 
                        record.type === 1 ? 
                            <Input type="text"
                                autoComplete="off"
                                placeholder={ Func.capitalizeFirstLetter((this.props.t('placeHolderForm.input') + " " + this.props.t("item.supplierCategory.keyList.content")).toLowerCase()) }
                                className="form-control" 
                                onChange={ (e) => this.onChange(idx, 'content', e.target.value) }
                                value={ record.content }/>
                            :
                            <InputNumber 
                                formatter={value => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                onChange={(value)=> this.onChange(idx, 'content', value)}
                                style={{width: '100%'}}
                                value={ checkUndefine(record.content) }
                            />
                }
            },
            keyLists: []
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.categoryKeys && !isEqual(nextProps.categoryKeys, this.props.categoryKeys)) {
            this.setState({
                keyLists: nextProps.categoryKeys
            });
        }
    }

    onChange = (idx, fieldName, value)=>{
        const { keyLists } = this.state;
        if(keyLists.length > 0){
            keyLists[idx][fieldName] = value;
            this.setState({ keyLists });
            this.props.onChangeKeyList(keyLists);
        }
    }

    render(){
        const {
            componentTable,
            titleItemTable,
            keyLists
        } = this.state;

        const { t } = this.props;

        return (
            keyLists.length > 0 && <ListComponent 
                tableKey="room-type-list"
                classChildren="p-0" classParent="m-0"
                style={{marginBottom: 15}}
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: false, size: 'large' }}
                dataSource={ Func.getDataSource(keyLists || [], ListCols) }
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'supplierCategory.keyList'
                })}
            />
        )
    }
}
export default class SupplierProductDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            supplierProduct: this.props.supplierState.detailProduct.supplierProduct,
            keyLists: [],
            isLoadRefIds: false,
            checkAllHotel: [],
            refIdDate: moment(),
        };
    }

    componentDidMount() {
        this.initDetail();
    }

    componentWillUnmount() {
        this.props.setSupplierProductDetail(new SupplierProduct())
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hotelState.hotelActives.length === nextProps.supplierState.detailProduct.supplierProduct.hotelIds.length){
            this.setState({
                checkAllHotel: ['all']
            })
        }
        if(nextProps.hotelState.hotelActives.length !== nextProps.supplierState.detailProduct.supplierProduct.hotelIds.length){
            this.setState({
                checkAllHotel: []
            })
        }
        if (nextProps.supplierState.detailProduct.supplierProduct && !isEqual(nextProps.supplierState.detailProduct.supplierProduct, this.props.supplierState.detailProduct.supplierProduct)) {
            this.setState({
                supplierProduct: nextProps.supplierState.detailProduct.supplierProduct,
                keyLists: nextProps.supplierState.detailProduct.supplierProduct.keyLists || [],
                action: nextProps.supplierState.detailProduct.supplierProduct.id ? 'UPDATE' : this.state.action
            });
        }
        if(nextProps.supplierState.productGenerate && !isEqual(nextProps.supplierState.productGenerate, this.props.supplierState.productGenerate)){
            this.onChange('productCode', nextProps.supplierState.productGenerate.code);
        }

        if(!this.state.isLoadRefIds && nextProps.supplierState.detailProduct.supplierProduct.supplierProductType && nextProps.supplierState.supplierAll && nextProps.supplierState.supplierAll.length){
            this.setState({isLoadRefIds: true});
            const siteCode = this.getSiteCodeTypeBySupplierId(nextProps.supplierState.detailProduct.supplierProduct.supplierId, nextProps.supplierState.supplierAll);
            this.getVinwonderRefIds(nextProps.supplierState.detailProduct.supplierProduct.supplierProductType, siteCode);
        }

        // group by for refId
        if(!isEqual(nextProps.supplierState.vinWonderRefIds, this.props.supplierState.vinWonderRefIds)){
            const newRefIds = nextProps.supplierState.vinWonderRefIds || [];
            const refIds = newRefIds.length
                ? groupBy(newRefIds, item => `(${item.rateCode}) ${item.rateName}`)
                : {};
            this.setState({vinWonderRefIds: refIds})

            // auto-select if previous refID exists in new list, otherwise reset
            // keep refID when list is empty (edit case)
            const { supplierProduct } = this.state;
            if(newRefIds.length && supplierProduct.refID != null && supplierProduct.rateCode != null){
                const found = newRefIds.find(
                    x => x.id == supplierProduct.refID && x.rateCode == supplierProduct.rateCode
                );
                if(!found){
                    this.onChange('refID', null);
                    this.onChange('rateCode', null);
                }
            }
        }
    }

    getProductSupplierType = ()=>{
        let arrOpt = toArray(SUPPLIER.PRODUCT_SUPPLIER.TYPE);
        if(arrOpt.length > 0){
            arrOpt = arrOpt.map((item)=>{
                return{
                    ...item,
                    label: this.props.t(`item.supplier.product.${item.label}`)
                }
            })
        }
        return arrOpt;
    }

    getAllHotelCheckbox = () => {
        return[{
            id: 3,
            key: 'allHotel',
            label: this.props.t('item.supplier.product.selectAllHotel'),
            value: 'all'
        }]
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option?.props?.children?.toString().toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    getRefIDKey = (refId, rateCode) => {
        if(refId != null && rateCode != null){
            return `${refId}-${rateCode}`;
        }
        return null;
    }

    getRefIfPopover = (refId, rateCode) => {
        let content = <i>Bạn chưa chọn REF ID</i>;
        if(refId != null && rateCode != null){
            const { vinWonderRefIds } = this.props.supplierState;
            const item = (vinWonderRefIds || []).find(x=>x.id == refId && x.rateCode == rateCode);
            if(item != null){
                content = <span><b>{`(${item.rateCode}) ${item.rateName}`}</b><br/>{item.id + " - (Giá: " + item.price + " ) " + item.display_name}</span>
            }
        }

        this.setState({ refIdPopoverConent: content });
    }

    render() {
        const { t, supplierState, supplierCategoryState, hotelState } = this.props;
        const { isFetchingProduct, supplierAll, vinWonderTypes } = supplierState;
        const { supplierCategoryAll } = supplierCategoryState;
        const { action, validation, supplierProduct, keyLists, vinWonderRefIds } = this.state;
        
        return (
            <LoadingComponent spinning={isFetchingProduct}>
                <PageListComponent className="supplier-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'suppliers'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.supplier.product.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.supplier.product.title')}`.toLowerCase()))
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isGetItem={false}
                        action={action}
                        onClickBack={this.onClickBack}
                        submitButtonRight={true}
                    >
                        <Wrapper className='col-md-12 p-0 m-0 bg-white'>
                            <FormWrapperItem>
                                <Wrapper className="col-md-12 row m-0 p-0">
                                    <Wrapper className="col-md-6">
                                        <FormWrapperInputComponent
                                            isRequired={ true }
                                            isValidation={true}
                                            dataValidation={supplierProduct.supplierTypes}
                                            validation={validation.supplierTypes}
                                            labelTitle={t(`item.supplier.product.typeSupplier`)}
                                        >
                                            <div>
                                                <CheckboxGroup
                                                    className="m-t"
                                                    options={ this.getProductSupplierType() }
                                                    value={ supplierProduct.supplierTypes }
                                                    onChange={ (values)=> this.onChange('supplierTypes', values)}/>
                                            </div>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <FormWrapperInputComponent
                                            isRequired={ true }
                                            isValidation={true}
                                            dataValidation={supplierProduct.supplierId}
                                            validation={validation.supplierId}
                                            labelTitle={t(`item.supplier.product.supplierName`)}
                                        >
                                            <AntSelect className="select-types"
                                               showArrow
                                               showSearch
                                               suffixIcon={<Icon type="search" />}
                                               filterOption={this.selectFilterSearch}
                                               placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.supplier.product.supplierName")).toLowerCase()) }
                                               value={ supplierProduct.supplierId }
                                               onChange={ id => this.handleChangeSupplier(id) }
                                               style={ { width: '100%' } }
                                            >
                                                { (supplierAll || []).map(item => (
                                                    <AntOption key={ item.id } value={ item.id }>
                                                        { item.supplierName }
                                                    </AntOption>
                                                )) }
                                            </AntSelect>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className='col-md-6'>
                                        <FormWrapperInputComponent
                                            isRequired={ true }
                                            isValidation={ true }
                                            dataValidation={ supplierProduct.name }
                                            validation={ validation.name }
                                            labelTitle={ t(`item.supplier.product.name`) }
                                        >
                                            <Input type="text"
                                                autoComplete="off"
                                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.supplier.product.name")).toLowerCase()) }
                                                className="form-control" name="name" onChange={ (e) => this.onChange('name', e.target.value) }
                                                value={ supplierProduct.name }/>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    {this.isVinwonderSupplier(supplierProduct.supplierId) && <div className="col-md-6 row m-0">
                                        <Wrapper className={`${supplierProduct.productType && 'col-md-12'} p-0 pr-md-2`}>
                                            <FormWrapperInputComponent
                                                isRequired={ true }
                                                isValidation={ true }
                                                dataValidation={ supplierProduct.supplierProductType }
                                                validation={ validation.supplierProductType }
                                                labelTitle={ Func.capitalizeFirstLetter((t('action.select') + " " + t("item.supplier.product.productType")).toLowerCase()) }
                                            >
                                                <AntSelect className="select-types"
                                                    showArrow
                                                    showSearch
                                                    filterOption={this.selectFilterSearch}
                                                    placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.supplier.product.productType")).toLowerCase()) }
                                                    value={ supplierProduct.supplierProductType }
                                                    onChange={ id => this.handleChangeSupplierProductType(id) }
                                                    style={ { width: '100%' } }
                                                    >
                                                        { (vinWonderTypes || []).map(item => (
                                                            <AntOption key={ item.id } value={ item.id }>
                                                                { item.name }
                                                            </AntOption>
                                                    )) }
                                                </AntSelect>
                                            </FormWrapperInputComponent>
                                        </Wrapper>
                                        {supplierProduct.productType && <Wrapper className='col-md-12 p-0'>
                                            <Wrapper className='row m-0 p-0'>
                                                <Wrapper className='col-md-4 p-0 pr-md-2'>
                                                    <FormWrapperInputComponent
                                                        labelTitle="Ngày REF ID"
                                                    >
                                                        <DatePicker
                                                            allowClear={false}
                                                            value={this.state.refIdDate}
                                                            onChange={this.handleChangeRefIdDate}
                                                            format="DD/MM/YYYY"
                                                            style={{ width: '100%' }}
                                                            placeholder="Chọn ngày"
                                                        />
                                                    </FormWrapperInputComponent>
                                                </Wrapper>
                                                <Wrapper className='col-md-8 p-0'>
                                                    <FormWrapperInputComponent
                                                        isRequired={ true }
                                                        isValidation={ true }
                                                        dataValidation={ supplierProduct.refID }
                                                        validation={ validation.refID }
                                                        labelTitle={ Func.capitalizeFirstLetter((t('action.select') + " " + t("item.supplier.product.refId"))) }
                                                    >
                                                        <Popover title={null} content={this.state.refIdPopoverConent} onVisibleChange={e => e && this.getRefIfPopover(supplierProduct.refID, supplierProduct.rateCode)}  >
                                                            <AntSelect className="select-types"
                                                                showArrow
                                                                showSearch
                                                                filterOption={this.selectFilterSearch}
                                                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.supplier.product.refId")).toLowerCase()) }
                                                                value={ this.getRefIDKey(supplierProduct.refID, supplierProduct.rateCode) }
                                                                onChange={ this.handleChangeRefId }
                                                                style={ { width: '100%' } }
                                                                dropdownClassName="ref-id-selector"
                                                                >
                                                                    {
                                                                        Object.keys(vinWonderRefIds || {}).map((key)=>{
                                                                            return (
                                                                                <AntOptGroup key={key} label={`Mã giá: ${key}`}>
                                                                                    { (vinWonderRefIds[key] || []).map(item => (
                                                                                        <AntOption key={ item.id } value={ this.getRefIDKey(item.id, item.rateCode) } data={item}>
                                                                                                { item.id + " - (Giá: " + item.price + " ) " + item.display_name }
                                                                                        </AntOption>
                                                                                        
                                                                                    )) }
                                                                                </AntOptGroup>
                                                                            )
                                                                        })

                                                                    }
                                                            </AntSelect>
                                                        </Popover>
                                                    </FormWrapperInputComponent>
                                                </Wrapper>
                                            </Wrapper>
                                        </Wrapper>}
                                    </div>}
                                    
                                    { action === 'UPDATE' && <Wrapper className='col-md-6'>
                                            <FormWrapperInputComponent
                                                isRequired={ true }
                                                labelTitle={ t(`item.supplier.product.productCode`) }
                                            >
                                                <Input type="text"
                                                    autoComplete="off"
                                                    className="form-control" name="productCode" onChange={ (e) => this.onChange('name', e.target.value) }
                                                    value={ supplierProduct.productCode }
                                                    disabled={true}
                                                />
                                                {/* { typeCheckCode && <span style={{color: 'red'}}>{t("item.supplier.product.invalidCode")}</span>} */}
                                            </FormWrapperInputComponent>
                                        </Wrapper>
                                    }

                                    <Wrapper className='col-md-6'>
                                        <FormWrapperInputComponent
                                            labelTitle={t(`item.supplier.product.description`)}
                                        >
                                            <Input.TextArea rows={3} placeholder="" type={`text`}
                                                className='form-control'
                                                name='description'
                                                value={supplierProduct.description} 
                                                onChange={ e => this.onChange('description', e.target.value) }
                                            />
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <FormWrapperInputComponent
                                            labelTitle={t(`item.supplier.product.supplierTypes`)}
                                            // typeInput={ true }
                                        >
                                            <AntSelect className="select-types"
                                               showArrow
                                               showSearch
                                               filterOption={this.selectFilterSearch}
                                               placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.supplier.product.typeTitle")).toLowerCase()) }
                                               value={ supplierProduct.categoryId }
                                               onChange={ channel => this.onChange('categoryId', channel) }
                                               style={ { width: '100%' } }
                                            >
                                                { 
                                                    (supplierCategoryAll || []).map(item => {
                                                        return (
                                                            <AntOption key={ item.id } value={ item.id }>
                                                                {`${ item.name } - ${ item.code }`}
                                                            </AntOption>
                                                        )
                                                    })
                                                }
                                            </AntSelect>
                                        </FormWrapperInputComponent>
                                        <FormWrapperInputComponent
                                            labelTitle={t(`item.supplier.product.keyList`)}
                                        >
                                            <KeylistComponent 
                                            {...this.props}
                                            categoryKeys={keyLists}
                                            onChangeKeyList={this._onChangeKeyList}
                                        />
                                        </FormWrapperInputComponent>
                                        
                                    </Wrapper>
                                    <Wrapper className='col-md-6'>
                                        <FormWrapperInputComponent
                                                // isRequired={ true }
                                                isValidation={true}
                                                dataValidation={supplierProduct.cost}
                                                validation={validation.cost}
                                                labelTitle={t(`item.supplier.product.cost`)}
                                                typeInput={ true }
                                            >
                                               <InputNumber 
                                                    formatter={value => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    // parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    style={{width: '100%'}}
                                                    value={ checkUndefine(supplierProduct.cost, false, true) }
                                                    onChange={(e)=> this.onChange('cost', e)}
                                                    disabled={this.isVinwonderSupplier(supplierProduct.supplierId)}
                                               />
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className='col-md-6'></Wrapper>
                                    {/* <Wrapper className='col-md-6'>
                                        <FormWrapperInputComponent
                                                isRequired={ true }
                                                isValidation={true}
                                                dataValidation={supplierProduct.sellCost}
                                                validation={validation.sellCost}
                                                labelTitle={t(`item.supplier.product.sellCost`)}
                                                typeInput={ true }
                                            >
                                               <InputNumber 
                                                    formatter={value => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    onChange={this.onChange}
                                                    style={{width: '100%'}}
                                                    value={ checkUndefine(supplierProduct.sellCost) }
                                                    onChange={(e)=> this.onChange('sellCost', e)}
                                               />
                                        </FormWrapperInputComponent>
                                    </Wrapper> */}
                                    <Wrapper className='col-md-6'>
                                        <FormWrapperInputComponent
                                            labelTitle={ t(`item.supplier.product.transactionCode`) }
                                            typeInput={ true }
                                        >
                                            <Input type="text"
                                                autoComplete="off"
                                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.supplier.product.transactionCode")).toLowerCase()) }
                                                className="form-control" name="transactionCode"
                                                value={ supplierProduct.transactionCode }
                                                onChange={ e => this.onChange('transactionCode', e.target.value) }
                                            />
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className='col-md-4'>
                                        <FormWrapperInputComponent
                                            labelTitle={t('item.supplier.product.hotel')}
                                             
                                            // typeInput={true}
                                        >
                                            <AntSelect
                                                className="select-types"
                                                showArrow
                                                mode="multiple"
                                                placeholder={Func.capitalizeFirstLetter(
                                                (
                                                    t("placeHolderForm.select") +
                                                    " " +
                                                    t("item.supplier.product.hotel")
                                                ).toLowerCase()
                                                )}
                                                filterOption={this.selectFilterSearch}
                                                value={supplierProduct.hotelIds}
                                                onChange={hotelId => this.onChange("hotelIds", hotelId)}
                                                style={{ width: "100%" }}
                                                
                                            >
                                                {
                                                    (hotelState?.hotelActives || []).map((hotel, index) => {
                                                        return(
                                                            <AntOption key={hotel.id} value={hotel.id}>
                                                               {hotel.code} - {hotel.name}
                                                            </AntOption>
                                                        )
                                                    })
                                                }
                                            </AntSelect>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className='col-md-2 mt-4'>
                                        <FormWrapperInputComponent
                                            // labelTitle="all"
                                            // typeInput={true}
                                        >
                                        
                                            <CheckboxGroup
                                                className="m-t"
                                                options={ this.getAllHotelCheckbox() }
                                                value={this.state.checkAllHotel }
                                                onChange={ (values)=> this.onChangeSelectAll('hotelAll', values)}
                                                />
                                        
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className='col-md-6'/>
                                    <Wrapper className='col-md-6'>
                                        <FormWrapperInputComponent
                                            labelTitle={t(`item.supplier.product.status`)}
                                            typeInput={ true }
                                        >
                                            <div>
                                                <Switch 
                                                    defaultChecked 
                                                    checked={supplierProduct.isActive === true} 
                                                    checkedChildren={t("item.supplier.product.isActive")}
                                                    unCheckedChildren={t("item.supplier.product.block")}
                                                    onChange={ check => this.onChange('isActive', check) }
                                                />
                                            </div>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                </Wrapper>
                            </FormWrapperItem>
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        const { match, supplierState } = this.props;
        let supplier = this.state.supplier;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: "UPDATE" });
            supplier = find(supplierState.suppliers, item => item.id === id) || supplier;
            if (supplier) this.setState({ supplier });
            this.props.getSupplierProductDetail(id);
        }
        // this.props.getAllSupplierProduct();
        this.props.getSupplierAll();
        this.props.getSupplierCategoryListAll();
        this.props.getVinWonderTypes();
        this.props.getAllHotelActive({isActive: true});
    }

    _onChangeKeyList = (arrKeyList)=>{
        this.onChange('keyLists', arrKeyList);
    }

    onChangeSelectAll = (fieldName, value) => {
        this.setState({checkAllHotel: value});
        if(value[0] === 'all'){
            const listHotelIds = (this.props.hotelState?.hotelActives || []).map(hotel => {
                return hotel.id;
            })
            this.onChange('hotelIds', listHotelIds)
        }else{
            this.onChange('hotelIds',[]);
        }
    }

    onChange = (fieldName, value) => {
        const supplierProduct = this.state.supplierProduct;
        const { supplierCategoryState } = this.props;
        const { supplierCategoryAll } = supplierCategoryState;
        supplierProduct[fieldName] = value;
        this.setState({ supplierProduct });
        // if(fieldName === 'productCode'){
        //     this.onCheckDefineCode(value);
        // }
        if(fieldName === 'categoryId'){
            const selectedIndex = findIndex(supplierCategoryAll, type => type.id === value);
            if(selectedIndex > -1){
                this.setState({keyLists: supplierCategoryAll[selectedIndex].categoryKeys});
                this.onChange('keyLists', supplierCategoryAll[selectedIndex].categoryKeys);
            }
        }

        if(fieldName === 'supplierId'){
            if(!this.isVinwonderSupplier(supplierProduct.supplierId)){
                this.onChange('productType', null);
                this.onChange('supplierProductType', null);
                this.onChange('refID', null);
            }
        }
        if(fieldName === 'hotelIds' && value.length !== this.props.hotelState.hotelActives.length){
            this.setState({checkAllHotel: []})
        }
        if(fieldName === 'hotelIds' && value.length === this.props.hotelState.hotelActives.length){
            this.setState({checkAllHotel: ['all']})
        }
    };

    // onCheckDefineCode = (value)=>{
    //     let isCheck = false;
    //     let length = value.length || 0;
    //     if(length > 5 || length < 3){ 
    //         isCheck = true;
    //     }
    //     this.setState({typeCheckCode: isCheck});
    // }

    onSubmit = (e) => {
        e.preventDefault();
        const { supplierProduct, action } = this.state;
        if (this.validate()) {
            if(action === 'CREATE'){
                this.props.createSupplierProduct(supplierProduct);
            }else{
                this.props.updateSupplierProduct(supplierProduct);
            }
        }
    };

    onClickBack = () => {
        this.props.history.push({ pathname: PATHS.SUPPLIER.LIST.path, state: {isTab: "PRODUCT"} });
    }

    validate() {
        const { t } = this.props;
        const { supplierProduct } = this.state;
        let validate = {
            required: {
                supplierId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.product.supplierName`)),
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.product.name`)),
                // productCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.product.productCode`)),
                // sellCost: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.product.sellCost`)),
            },
            minValueNumber: {
                cost: Func.formatValidation(t('validation.statusCode.code.VALUE_MUST_GREATER_THAN_ZERO'), t(`item.supplier.product.cost`)),
            },
            minLength: {
                supplierTypes: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.product.productType`)),
            },
        };

        if(this.isVinwonderSupplier(supplierProduct.supplierId)){
            validate.required.productType = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.product.productType`));
        }

        if(this.isVinwonderSupplier(supplierProduct.supplierId)){
            validate.required.refID = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.product.refId`));
        }

        let valueValidate = {
            minLength: {
                supplierTypes: 1,
            },
            minValueNumber: {
                cost: 0,
            }
        };
        const result = Func.multipleValidate(this.state.supplierProduct, validate, valueValidate);
        
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    handleChangeSupplier = (supplierId) => {
        const siteCode = this.getSiteCodeTypeBySupplierId(supplierId);
        this.getVinwonderRefIds(this.state.supplierProduct?.supplierProductType, siteCode);

        if(this.isVinwonderSupplier(supplierId)){
            this.onChange('productType', RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.id);
        }else{
            this.onChange('productType', null);
        }

        this.onChange('supplierId', supplierId);
        this.onChange('refID', null);
    }
    
    handleChangeSupplierProductType = (supplierProductTypeId) => {
        this.onChange('supplierProductType', supplierProductTypeId);
        this.onChange('refID', null);
        const siteCode = this.getSiteCodeTypeBySupplierId(this.state.supplierProduct?.supplierId);
        this.getVinwonderRefIds(supplierProductTypeId, siteCode);
    }

    getVinwonderRefIds(supplierProductTypeId, siteCode, date){
        this.props.setVinwonderRefIds([]);
        if(supplierProductTypeId && siteCode){
            const dateStr = (date || this.state.refIdDate || moment()).format('YYYY/MM/DD');
            this.props.getVinwonderRefIds({siteCode: siteCode, vinWonderType: supplierProductTypeId, date: dateStr});
        }
    }

    handleChangeRefIdDate = (date) => {
        this.setState({ refIdDate: date });
        const siteCode = this.getSiteCodeTypeBySupplierId(this.state.supplierProduct?.supplierId);
        this.getVinwonderRefIds(this.state.supplierProduct?.supplierProductType, siteCode, date);
    }

    isVinwonderSupplier = (supplierId) => {
        const { supplierState } = this.props;
        const { supplierAll } = supplierState;
        const item = (supplierAll || []).find(x=>x.id === supplierId);
        return item?.supplierType === RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.id;
    }

    getSiteCodeTypeBySupplierId = (id, supplierList = null) => {
        const { supplierState } = this.props;
        let { supplierAll } = supplierState;
        if(supplierList != null){
            supplierAll = supplierList;
        }
        const item = (supplierAll || []).find(x=>x.id === id);
        return item?.siteCode;
    }

    handleChangeRefId = (id, option) => {
        this.onChange('refID', option.props.data?.id);
        this.onChange('rateCode', option.props.data?.rateCode || null);
        this.onChange('cost', option.props.data?.price || 0.0);
    }
}
